import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { ZipCodeFloridaComponent } from './zip-code-florida.component';

const routes: Routes = [{
  path: 'zip-code-florida',
  component: ZipCodeFloridaComponent,
  data: {
    title: 'Zip Code Floridad'
  }
}];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
  providers: []
})
export class ZipCodeFloridaRoutingModule { }



// WEBPACK FOOTER //
// ./src/app/pages/zip-code-florida/zip-code-florida.routing.module.ts